import type { ReactNode } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LayoutMain from '@/layouts/LayoutMain';
import LayoutAuthSplit from '@/layouts/LayoutAuthSplit';
import PageEmConstrucao from '@/pages/PageEmConstrucao';
import { RequireAuth } from '@/components/RequireAuth';
import { RequirePermission } from '@/components/RequirePermission';
import { PUBLIC_ROUTES, APP_ROUTES, type AppRoute } from '@/config/routes';

// Aplica o guard de PERFIL na rota (quando a rota declara uma permissão).
// A AUTENTICAÇÃO é feita uma vez no layout, via <RequireAuth /> (abaixo).
function withPermission({ element, permission }: AppRoute): ReactNode {
  if (!permission) return element;
  return <RequirePermission code={permission}>{element}</RequirePermission>;
}

export default function App() {
  return (
    <Routes>
      {/* Públicas (login + recuperar senha): tela dividida (painel de marca + card). */}
      <Route element={<LayoutAuthSplit />}>
        {PUBLIC_ROUTES.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Route>

      {/* App (com sidebar). RequireAuth bloqueia toda rota sem token,
          redirecionando pro login. Só /login e /recuperar-senha ficam públicas. */}
      <Route
        element={
          <RequireAuth>
            <LayoutMain />
          </RequireAuth>
        }
      >
        {APP_ROUTES.map((r) => (
          <Route key={r.path} path={r.path} element={withPermission(r)} />
        ))}

        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="*" element={<PageEmConstrucao />} />
      </Route>
    </Routes>
  );
}
